import { Nullable } from 'src/core/common/domain/types/types';

export type NotificationPrimitives = {
  id: string;
  title: string;
  body: string;
  created_at: string; // ISO 8601 (ATOM)
  read_at: Nullable<string>; // ISO 8601 (ATOM) or null when unread
  is_read: boolean;
  custom_action: string;
  custom_value: string;
  custom_id: string;
};

export class Notification {
  constructor(
    public readonly id: string,
    public readonly title: string,
    public readonly body: string,
    public readonly createdAt: string,
    public readonly readAt: Nullable<string>,
    public readonly isRead: boolean,
    public readonly customAction: string,
    public readonly customValue: string,
    public readonly customId: string
  ) {}

  static fromPrimitives(primitives: NotificationPrimitives): Notification {
    return new this(
      primitives.id,
      primitives.title,
      primitives.body,
      primitives.created_at,
      primitives.read_at ?? null,
      primitives.is_read,
      primitives.custom_action,
      primitives.custom_value,
      primitives.custom_id
    );
  }

  // Returns a read copy, so the UI can update optimistically without refetching.
  asRead(): Notification {
    return new Notification(
      this.id,
      this.title,
      this.body,
      this.createdAt,
      this.readAt,
      true,
      this.customAction,
      this.customValue,
      this.customId
    );
  }

  toPrimitives(): NotificationPrimitives {
    return {
      id: this.id,
      title: this.title,
      body: this.body,
      created_at: this.createdAt,
      read_at: this.readAt,
      is_read: this.isRead,
      custom_action: this.customAction,
      custom_value: this.customValue,
      custom_id: this.customId,
    };
  }
}
